import React, {useState,useEffect,useMemo} from 'react';
import Loader from 'react-loader-spinner';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import 'rc-time-picker/assets/index.css';
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import { useSelector,useDispatch } from 'react-redux'
import { updateOwnerManager, getOwnerManager } from '../Redux/AccountSettings/AccountSettingsActions';

function AddOwnerManager(){
  // store data access start
const accountsettings_data = useSelector(state =>state.AccountSettings)
// store data access End
  const dispatch = useDispatch()  // for accessing the redux function

  // component all states define start
  const [ownerResult,setOwnerResult] = useState();
  const [ownerManager, setOwnerManager] = useState();
  const [inputValues,setInputValues] = useState({
                                          manager_name:"",
                                          owner_name:""
  });

  const [error,setError] = useState(null);

useEffect(() =>{
    dispatch(getOwnerManager())
  },[dispatch])
  // fetch allBook api hook End

  useMemo(() =>{
    if(accountsettings_data && accountsettings_data.get_owner_manager && accountsettings_data.get_owner_manager.object){
      setInputValues(accountsettings_data.get_owner_manager.object)
    }
  },[accountsettings_data])

// add data of classes api into constant,hook start
   useMemo(() =>{
     if(accountsettings_data && accountsettings_data.owner_manager && accountsettings_data.owner_manager.object && accountsettings_data.owner_manager.success_status === true){
      setOwnerResult(accountsettings_data.owner_manager.object)
     }
   },[accountsettings_data])
// add data of classes api into constant,hook End
// examHandler function start
  const addOwnerManagerHandler = (event) =>{
     event.preventDefault()
     dispatch(updateOwnerManager(inputValues.manager_name, inputValues.owner_name));
  }
// examHandler function End

// resetHandler function start
   const resetHandler = (event) =>{
     event.preventDefault()
     window.location.reload(false);
   }
// resetHandler function End

        return (
            <div className="col-6-xxxl col-12">
                <div className="card height-auto">

                {accountsettings_data.is_loading === true ? (<div className="card-body">
                      <div className="Student-Loader">
                      <Loader
                      className = "student-detail-loader"
                    type="MutatingDots"
                    color="#fea801"
                    height={150}
                    width={150}
                   />
                      </div>
                    </div>)
                   :
                  (<div className="card-body">
                    
                    <div className="heading-layout1 bg-darkblue">
                      <div className="item-title">
                        <h3 className='text-light'>Add Owner And Manager Name</h3>
                        
                      </div>
                    </div>

                    {accountsettings_data.owner_manager && accountsettings_data.owner_manager.request_status === true ? (<div className="success-greeting1">
                        <h2 className="addtimesuccess">Owner Manager Added Successfully!</h2>
                        </div>): null}
                        {accountsettings_data.get_error && accountsettings_data.get_error.object && accountsettings_data.get_error.object.error ? (<div className="success-greeting1">
                        <h2 className="addtimeerror">{accountsettings_data.get_error.object.error}</h2>
                        </div>): null}
                    
                    <form className="new-added-form" onSubmit={(e) =>addOwnerManagerHandler(e)}>
                      <div className="row">
                        
                        <div className="col-12-xxxl col-lg-6 col-12 form-group">
                          <label>Owner Name *</label>
                          <input type="text" placeholder className="form-control" value={inputValues.owner_name} onChange={(e) =>setInputValues({...inputValues,owner_name:e.target.value})} required/>
                          {error != null && error.owner_name ? (<h6 className="addStudent-error">*{JSON.stringify(error.owner_name).replace(/[\[\]"]+/g,"")}</h6>):null}
                        </div>

                        <div className="col-12-xxxl col-lg-6 col-12 form-group">
                          <label>Manager Name *</label>
                          <input type="text" placeholder className="form-control" value={inputValues.manager_name} onChange={(e) =>setInputValues({...inputValues,manager_name:e.target.value})} required/>
                          {error != null && error.manager_name ? (<h6 className="addStudent-error">*{JSON.stringify(error.manager_name).replace(/[\[\]"]+/g,"")}</h6>):null}
                        </div>

                        <div className="col-12 form-group mg-t-8" style={{paddingTop:"20px"}}>
                          <button type="submit" style={{marginLeft:"10px"}} className="btn-fill-lg bg-blue-dark btn-hover-yellow right-float">Save</button>
                          <button type="reset" className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark right-float" onClick={(e) =>resetHandler(e)}>Reset</button>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
                </div>
              </div>
        );
}

export default AddOwnerManager;
